import React, { useState, useEffect, useRef, useMemo } from 'react';
import { getDadosContratos, postFormulario, getConfiguracaoCompetencia, putConfiguracaoCompetencia } from '../../api';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import { getUsuarioLogado, getRoleFromToken } from '../../api';
import SideBarNavFaturamento from '../../componets/SideBarNavFaturamento';
import { DARK_THEME_PAINEL_EXECUTIVO, LIGHT_THEME_PAINEL_EXECUTIVO } from '../../componets/temas';
// ─── Modal de Saldo Insuficiente ─────────────────────────────────────────────
const SaldoModal = ({ bloqueios, onClose }) => {
  const formatarData = (iso) => {
    const [ano, mes] = iso.split('-');
    return `${mes}/${ano}`;
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 flex flex-col items-center text-center animate-fade-in">
        <div className="w-20 h-20 rounded-full flex items-center justify-center mb-5 bg-amber-100">
          <svg className="w-10 h-10 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold mb-2 text-amber-700">Saldo Bruto insuficiente</h2>
        <p className="text-sm text-gray-500 mb-5 leading-relaxed">
          A solicitação não pode ser enviada. As competências abaixo não possuem saldo disponível na planilha de controle:
        </p>
        <ul className="w-full space-y-2 mb-6 text-left">
          {bloqueios.map((b, i) => (
            <li key={i} className="bg-amber-50 border border-amber-200 rounded-lg px-4 py-3 text-sm">
              <span className="font-semibold text-amber-800">{b.projeto}</span>
              <span className="text-amber-700"> — {formatarData(b.competencia)}</span>
              {b.saldo_bruto !== undefined && (
                <div className="mt-1 flex gap-4 text-xs">
                  <span className="text-red-600">Saldo disponível: <strong>{b.saldo_bruto.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></span>
                  <span className="text-amber-700">Solicitado: <strong>{b.valor_solicitado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong></span>
                </div>
              )}
              <p className="text-xs text-amber-600 mt-1">{b.motivo}</p>
            </li>
          ))}
        </ul>
        <button
          onClick={onClose}
          className="w-full py-3 rounded-xl font-semibold text-sm bg-amber-500 text-white hover:bg-amber-600 transition-all"
        >
          Revisar solicitação
        </button>
      </div>
    </div>
  );
};
// ─────────────────────────────────────────────────────────────────────────────

// ─── Modal de feedback ───────────────────────────────────────────────────────
const FeedbackModal = ({ tipo, onClose }) => {
  const isSuccess = tipo === 'success';

  return (
    
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 flex flex-col items-center text-center animate-fade-in">
        <div className={`w-20 h-20 rounded-full flex items-center justify-center mb-5 ${isSuccess ? 'bg-purple-100' : 'bg-red-100'}`}>
          {isSuccess ? (
            <svg className="w-10 h-10 text-purple-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          ) : (
            <svg className="w-10 h-10 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          )}
        </div>
        <h2 className={`text-2xl font-bold mb-2 ${isSuccess ? 'text-gray-900' : 'text-red-600'}`}>
          {isSuccess ? 'Solicitação enviada!' : 'Erro ao enviar'}
        </h2>
        <p className="text-sm text-gray-500 mb-8 leading-relaxed">
          {isSuccess
            ? 'Sua solicitação de emissão de NFSe foi registrada com sucesso. Você pode conferir o lançamento na planilha de controle.'
            : 'Não foi possível enviar o formulário. Verifique sua conexão e os dados preenchidos, então tente novamente.'}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 w-full">
          <button
            onClick={onClose}
            className={`flex-1 py-3 rounded-xl font-semibold text-sm transition-all border ${
              isSuccess
                ? 'border-gray-200 text-gray-600 hover:bg-gray-50'
                : 'bg-red-500 text-white border-red-500 hover:bg-red-600'
            }`}
          >
            {isSuccess ? 'Fechar' : 'Tentar novamente'}
          </button>
        </div>
      </div>
    </div>
  );
};
// ─────────────────────────────────────────────────────────────────────────────

// ─── Modal de edição do dia limite de competência (admin) ───────────────────
const DiaLimiteModal = ({ valorAtual, onClose, onSalvar }) => {
  const [valor, setValor] = useState(String(valorAtual ?? 5));
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const handleSalvar = async () => {
    const numero = Number(valor);
    if (!Number.isInteger(numero) || numero < 1 || numero > 28) {
      setErro('Informe um dia entre 1 e 28.');
      return;
    }
    setSalvando(true);
    setErro('');
    try {
      await onSalvar(numero);
    } catch (e) {
      setErro(e.message || 'Erro ao salvar. Tente novamente.');
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm p-8 flex flex-col items-center text-center animate-fade-in">
        <h2 className="text-xl font-bold mb-2 text-gray-900">Editar carência de competência</h2>
        <p className="text-sm text-gray-500 mb-5 leading-relaxed">
          Dia do mês até o qual uma competência do mês anterior ainda não é considerada fechada.
        </p>
        <input
          type="number"
          min="1"
          max="28"
          value={valor}
          onChange={e => setValor(e.target.value)}
          className="w-24 text-center text-2xl font-mono border-b-2 border-purple-300 focus:border-purple-600 outline-none py-1 mb-2"
          autoFocus
        />
        {erro && <p className="text-xs text-red-500 mb-2">{erro}</p>}
        <div className="flex gap-3 w-full mt-4">
          <button
            type="button"
            onClick={onClose}
            disabled={salvando}
            className="flex-1 py-3 rounded-xl font-semibold text-sm border border-gray-200 text-gray-600 hover:bg-gray-50 transition-all disabled:opacity-50"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={handleSalvar}
            disabled={salvando}
            className="flex-1 py-3 rounded-xl font-semibold text-sm bg-purple-900 text-white hover:bg-black transition-all disabled:opacity-50"
          >
            {salvando ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </div>
    </div>
  );
};
// ─────────────────────────────────────────────────────────────────────────────

// Estado inicial limpo das competências
const COMPETENCIA_VAZIA = () => ({ data: '', valor: '' });

const userInicial = getUsuarioLogado();

const GoogleFormFinanceiro = () => {
  const [listaContratos, setListaContratos] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null); // null | 'success' | 'error'
  const [modalSaldo, setModalSaldo] = useState(null); // null | bloqueios[]
  const [diaLimiteCompetencia, setDiaLimiteCompetencia] = useState(null);
  const [modalDiaLimite, setModalDiaLimite] = useState(false);
  const isAdmin = getRoleFromToken() === 'admin';
  const [buscaContrato, setBuscaContrato] = useState('');
  const [dropdownAberto, setDropdownAberto] = useState(false);
  const comboboxRef = useRef(null);
  const [isLight, setisLight] = useState(true);
  const C = isLight ? LIGHT_THEME_PAINEL_EXECUTIVO : DARK_THEME_PAINEL_EXECUTIVO;
  // ─── Competências: array de { data, valor } ──────────────────────────────
  const [competencias, setCompetencias] = useState([COMPETENCIA_VAZIA()]);

  const [formData, setFormData] = useState({
    email: userInicial?.sub || '',
    gerente_projetos: '',
    prestador_servicos: '',
    prestador_outro: '',
    razao_social: '',
    cnpj: '',
    descricao: '',
    numero_contrato: '',
    nome_projeto: '',
    valor: '',
    emails_nota_fiscal: 'erika.machado@youxgroup.com.br,matheus.cunha@youxgroup.com.br',
    data_faturamento: '',
    documentos_extras: '',
    observacoes_gerais: ''
  });

  // ─── Cálculo de validação das competências ────────────────────────────────
  const somaCompetencias = competencias.reduce((acc, c) => {
    const v = parseFloat(c.valor);
    return acc + (isNaN(v) ? 0 : v);
  }, 0);

  const valorTotal = parseFloat(formData.valor) || 0;

  // Tolerância de R$ 0,01 para evitar problemas de ponto flutuante
  const competenciasValidas =
    competencias.every(c => c.valor !== '') &&
    Math.abs(somaCompetencias - valorTotal) < 0.01;

  const mostrarAvisoCompetencia =
    valorTotal > 0 &&
    competencias.some(c => c.valor !== '') &&
    !competenciasValidas;

  // ─── Combobox contrato ────────────────────────────────────────────────────
  const contratosFiltrados = useMemo(() => {
    const sorted = [...listaContratos].sort((a, b) =>
      (a.Contrato || '').localeCompare(b.Contrato || '', 'pt-BR')
    );
    const porPrestador = ['GT4W', 'CRIA', 'CIGTA', 'FLOW'].includes(formData.prestador_servicos)
      ? sorted.filter(item => item.Prestador === formData.prestador_servicos)
      : sorted;
    const termo = buscaContrato.trim().toLowerCase();
    if (!termo) return porPrestador;
    return porPrestador.filter(item =>
      (item.Contrato || '').toLowerCase().includes(termo)
    );
  }, [listaContratos, buscaContrato, formData.prestador_servicos]);

  useEffect(() => {
    const fechar = (e) => {
      if (comboboxRef.current && !comboboxRef.current.contains(e.target)) {
        setDropdownAberto(false);
      }
    };
    document.addEventListener('mousedown', fechar);
    return () => document.removeEventListener('mousedown', fechar);
  }, []);

  const handleSelecionarContrato = (contrato) => {
    handleChange({ target: { name: 'numero_contrato', value: contrato } });
    setBuscaContrato('');
    setDropdownAberto(false);
  };
  // ─────────────────────────────────────────────────────────────────────────

  // ─── Handlers de competência ──────────────────────────────────────────────
  const handleCompetenciaChange = (index, field, value) => {
    setCompetencias(prev => {
      const nova = [...prev];
      nova[index] = { ...nova[index], [field]: value };
      return nova;
    });
  };

  const addCompetencia = () => {
    setCompetencias(prev => [...prev, COMPETENCIA_VAZIA()]);
  };

  const removeCompetencia = (index) => {
    setCompetencias(prev => prev.filter((_, i) => i !== index));
  };

  // ─── Carregamento inicial ─────────────────────────────────────────────────
  useEffect(() => {
    const carregarDados = async () => {
      try {
        const response = await getDadosContratos();
        if (response.success) setListaContratos(response.data);
      } catch (error) {
        console.error('Erro ao carregar lista de contratos:', error);
      } finally {
        setLoading(false);
      }
    };
    carregarDados();
  }, []);

  useEffect(() => {
    const user = getUsuarioLogado();
    if (user?.sub) {
      setFormData(prev => ({ ...prev, email: user.sub }));
    }
  }, []);

  useEffect(() => {
    const carregarConfiguracaoCompetencia = async () => {
      try {
        const config = await getConfiguracaoCompetencia();
        setDiaLimiteCompetencia(config.dia_limite_competencia);
      } catch (error) {
        console.error('Erro ao carregar configuração de competência:', error);
      }
    };
    carregarConfiguracaoCompetencia();
  }, []);

  const handleSalvarDiaLimite = async (novoDia) => {
    const config = await putConfiguracaoCompetencia({ dia_limite_competencia: novoDia });
    setDiaLimiteCompetencia(config.dia_limite_competencia);
    setModalDiaLimite(false);
  };

  // ─── handleChange geral ───────────────────────────────────────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => {
      let newData = { ...prev, [name]: value };

      if (name === 'numero_contrato') {
        const contratoInfo = listaContratos.find(item => item.Contrato === value);
        if (contratoInfo) {
          newData.nome_projeto = contratoInfo.Projeto || '';
          newData.razao_social = contratoInfo.Cliente || '';
          newData.cnpj = contratoInfo.CNPJ || '';
        }
      }

      if (name === 'prestador_servicos' && prev.numero_contrato) {
        const contratoAtual = listaContratos.find(item => item.Contrato === prev.numero_contrato);
        if (!contratoAtual || contratoAtual.Prestador !== value) {
          newData.numero_contrato = '';
          newData.nome_projeto = '';
          newData.razao_social = '';
          newData.cnpj = '';
        }
      }
      return newData;
    });
  };

  // ─── Submit ───────────────────────────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validação final das competências antes de enviar
    if (!competenciasValidas) return;

    setIsSubmitting(true);

    const payload = { ...formData };
    if (payload.prestador_servicos === 'Outro') {
      payload.prestador_servicos = payload.prestador_outro;
    }
    // Serializa competências como array de objetos
    payload.competencias = competencias;

    try {
      await postFormulario(payload);

      // Reset do formulário
      setFormData({
        email: userInicial?.sub || '',
        gerente_projetos: '',
        prestador_servicos: '',
        prestador_outro: '',
        razao_social: '',
        cnpj: '',
        descricao: '',
        numero_contrato: '',
        nome_projeto: '',
        valor: '',
        emails_nota_fiscal: 'erika.machado@youxgroup.com.br,matheus.cunha@youxgroup.com.br',
        data_faturamento: '',
        documentos_extras: '',
        observacoes_gerais: ''
      });
      setCompetencias([COMPETENCIA_VAZIA()]);
      setModal('success');
    } catch (error) {
      if (error.data?.tipo === 'saldo_insuficiente') {
        setModalSaldo(error.data.bloqueios);
      } else {
        setModal('error');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFecharModal = () => setModal(null);

  const navigate = useNavigate();

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
      <div style={{
          display: "flex",
          height: "100vh", // Ocupa a altura exata da janela
          overflow: "hidden", // Impede que a página inteira role
          background: C.bg,
          fontFamily: "'DM Sans','Segoe UI',sans-serif",
          color: C.text,
        }}>
      {modal && <FeedbackModal tipo={modal} onClose={handleFecharModal} />}
      {modalSaldo && <SaldoModal bloqueios={modalSaldo} onClose={() => setModalSaldo(null)} />}
      {modalDiaLimite && (
        <DiaLimiteModal
          valorAtual={diaLimiteCompetencia}
          onClose={() => setModalDiaLimite(false)}
          onSalvar={handleSalvarDiaLimite}
        />
      )}
              <SideBarNavFaturamento isLight={isLight} userRole={getRoleFromToken()} />
        <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "auto" }}>

      {/* Cabeçalho YOUX GROUP */}
      <header className="bg-gradient-to-r from-purple-900 to-pink-800 text-white px-6 py-4 flex justify-between items-center shadow-lg mb-6">
        <div className="flex items-center space-x-2">
          <span className="text-2xl font-bold tracking-tighter">YOUX</span>
          <span className="text-xl font-light">GROUP</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.25)', borderRadius: 8, padding: '7px 12px', fontSize: 13 }}>
            <span>Carência competência: dia {diaLimiteCompetencia ?? '...'}</span>
            {isAdmin && (
              <button
                type="button"
                onClick={() => setModalDiaLimite(true)}
                title="Editar dia limite"
                style={{ display: 'flex', alignItems: 'center', background: 'transparent', border: 'none', cursor: 'pointer', padding: 2, color: '#fff' }}
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </button>
            )}
          </div>
          <button
            onClick={() => navigate('/inicio')}
            style={{ display: 'flex', alignItems: 'center', gap: 6, background: 'rgba(255,255,255,0.12)', border: '1px solid rgba(255,255,255,0.25)', borderRadius: 8, padding: '7px 14px', cursor: 'pointer', color: '#fff', fontSize: 13, fontWeight: 600 }}
          >
            Menu Principal
          </button>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4">
        {/* Banner de Título */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm mb-4 overflow-hidden border-t-8 border-t-purple-900">
          <div className="p-8">
            <h1 className="text-3xl font-semibold text-gray-900 mb-2">Solicitação - Emissão de NFSe</h1>
            <p className="text-sm text-gray-500">O objetivo principal deste formulário é coletar todas as informações necessárias para a emissão da nota fiscal solicitada pelo cliente e gerar uma base de dados única para uso em todos os departamentos.</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">

          {/* Email */}
          <section className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
            <label className="block text-base font-medium text-gray-900 mb-1">E-mail *</label>
            <p className="text-xs text-gray-400 mb-3">Preenchido automaticamente com o e-mail do usuário logado.</p>
            <div className="flex items-center gap-2 border-b border-gray-300 py-1">
              <svg className="w-4 h-4 text-purple-700 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 11V7a4 4 0 10-8 0v4M5 11h14l1 9H4l1-9z" />
              </svg>
              <input
                name="email"
                type="email"
                required
                readOnly
                value={formData.email}
                className="w-full bg-transparent outline-none text-gray-600 cursor-not-allowed text-sm"
              />
            </div>
          </section>

          {/* Gerentes */}
          <section className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
            <label className="block text-base font-medium text-gray-900 mb-4">Gerente de Projetos *</label>
            <div className="grid grid-cols-1 sm:grid-cols-1 gap-3">
              {['Luana Teixeira', 'Marcos Reis','Wakiria Melo' ].map(nome => (
                <label key={nome} className="flex items-center space-x-3 cursor-pointer group">
                  <input type="radio" name="gerente_projetos" value={nome} checked={formData.gerente_projetos === nome} onChange={handleChange} className="accent-purple-800 h-4 w-4" required />
                  <span className="text-sm text-gray-700 group-hover:text-black">{nome}</span>
                </label>
              ))}
            </div>
          </section>

          {/* Prestador */}
          <section className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
            <label className="block text-base font-medium text-gray-900 mb-4">Prestador de Serviços *</label>
            <div className="space-y-3">
              {['GT4W', 'CRIA', 'CIGTA', 'FLOW', 'Outro'].map(op => (
                <label key={op} className="flex items-center space-x-3">
                  <input
                    type="radio"
                    name="prestador_servicos"
                    value={op}
                    checked={formData.prestador_servicos === op}
                    onChange={handleChange}
                    className="accent-purple-800 h-4 w-4"
                    required
                  />
                  <span className="text-sm text-gray-700">{op}</span>
                </label>
              ))}
              {formData.prestador_servicos === 'Outro' && (
                <input name="prestador_outro" value={formData.prestador_outro} onChange={handleChange} placeholder="Nome do prestador" className="ml-7 w-2/3 border-b border-gray-300 py-1 outline-none text-sm" />
              )}
            </div>
          </section>

          {/* Nº do Contrato */}
          <section className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm ring-1 ring-purple-100">
            <label className="block text-base font-medium text-gray-900 mb-4">Nº do contrato *</label>
            <div ref={comboboxRef} className="relative">
              <div className={`flex items-center border rounded overflow-hidden transition-all ${dropdownAberto ? 'border-purple-500 ring-2 ring-purple-500' : 'border-gray-300'}`}>
                <input
                  type="text"
                  value={buscaContrato}
                  onChange={e => { setBuscaContrato(e.target.value); setDropdownAberto(true); }}
                  onFocus={() => setDropdownAberto(true)}
                  placeholder={loading ? 'Carregando contratos...' : formData.numero_contrato || 'Selecione ou digite o contrato'}
                  className="flex-1 px-3 py-2 text-sm outline-none bg-white"
                />
                {formData.numero_contrato && !buscaContrato && (
                  <span className="px-3 py-2 text-sm text-purple-700 font-medium truncate max-w-xs bg-purple-50 border-l border-purple-200">
                    {formData.numero_contrato}
                  </span>
                )}
                <button
                  type="button"
                  onClick={() => setDropdownAberto(v => !v)}
                  className="px-2 py-2 text-gray-400 hover:text-gray-600"
                  tabIndex={-1}
                >
                  <svg className={`w-4 h-4 transition-transform ${dropdownAberto ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
              </div>
              {dropdownAberto && (
                <ul className="absolute z-20 w-full bg-white border border-gray-200 rounded-lg shadow-xl mt-1 max-h-64 overflow-y-auto">
                  {contratosFiltrados.length === 0 ? (
                    <li className="px-4 py-3 text-sm text-gray-400 text-center">Nenhum contrato encontrado</li>
                  ) : (
                    contratosFiltrados.map((item, idx) => (
                      <li
                        key={idx}
                        onMouseDown={() => handleSelecionarContrato(item.Contrato)}
                        className={`px-4 py-2 text-sm cursor-pointer transition-colors ${formData.numero_contrato === item.Contrato ? 'bg-purple-50 text-purple-800 font-medium' : 'text-gray-700 hover:bg-gray-50'}`}
                      >
                        {item.Contrato}
                      </li>
                    ))
                  )}
                </ul>
              )}
            </div>
            {/* input oculto para manter required nativo do form */}
            <input
              type="text"
              required
              value={formData.numero_contrato}
              onChange={() => {}}
              className="sr-only"
              tabIndex={-1}
            />
          </section>

          {/* Dados Automáticos */}
          <section className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm grid grid-cols-1 md:grid-cols-2 gap-6 bg-gray-50/30">
            <div>
              <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Razão Social (Auto)</label>
              <input name="razao_social" value={formData.razao_social} readOnly className="w-full border-b border-gray-200 bg-transparent py-1 text-gray-500 outline-none cursor-not-allowed" />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-400 uppercase mb-2">CNPJ (Auto)</label>
              <input name="cnpj" value={formData.cnpj} readOnly className="w-full border-b border-gray-200 bg-transparent py-1 text-gray-500 outline-none cursor-not-allowed" />
            </div>
            <div className="md:col-span-2">
              <label className="block text-xs font-bold text-gray-400 uppercase mb-2">Projeto (Auto)</label>
              <input name="nome_projeto" value={formData.nome_projeto} readOnly className="w-full border-b border-gray-200 bg-transparent py-1 text-gray-500 outline-none cursor-not-allowed" />
            </div>
          </section>

          {/* Descrição e Valor */}
          <section className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm space-y-6">
            <div>
              <label className="block text-base font-medium text-gray-900 mb-2">Descrição *</label>
              <label className="block text-sm text-gray-700 mb-2">Informar a descrição dos serviços realizados a serem inseridos no corpo da NF.</label>
              <textarea name="descricao" rows="2" required value={formData.descricao} onChange={handleChange} className="w-full border-b border-gray-300 focus:border-purple-600 outline-none py-1 text-sm" />
            </div>
            <div>
              <label className="block text-base font-medium text-gray-900 mb-2">Valor (R$) *</label>
              <label className="block text-sm text-gray-700 mb-2">Inserir valor total da prestação do serviço. Adicionar duas casas decimais após a vírgula.</label>
              <input name="valor" type="number" step="0.01" required value={formData.valor} onChange={handleChange} onWheel={e => e.target.blur()} placeholder="0,00" className="w-full border-b border-gray-300 focus:border-purple-600 outline-none py-1 font-mono [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none" />
            </div>
          </section>

          {/* E-mails NF */}
          <section className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
            <label className="block text-sm font-medium text-gray-700 mb-2">E-mails p/ Nota Fiscal *</label>
            <label className="block text-sm text-gray-700 mb-2">A NFS-e será enviada automaticamente para os e-mails informados neste campo após a emissão. Caso deseje incluir mais de um e-mail, separe-os por vírgula. (APENAS E-MAILS)</label>
            <input name="emails_nota_fiscal" required value={formData.emails_nota_fiscal} onChange={handleChange} className="w-full border-b border-gray-300 outline-none py-1 text-sm" />
          </section>

          {/* Data Faturamento */}
          <section className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
            <label className="block text-sm font-medium text-gray-700 mb-2">Data Faturamento</label>
            <input name="data_faturamento" type="date" value={formData.data_faturamento} onChange={handleChange} className="w-full border-b border-gray-300 outline-none py-1" />
          </section>

          {/* ── Competências ─────────────────────────────────────────────────── */}
          <section className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">

            {/* Cabeçalho */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">Competência *</label>
              <p className="text-xs text-gray-400 mt-1">
                Informe o mês/ano de competência gerencial e o valor correspondente.
                A soma dos valores deve ser igual ao valor total da nota.
                A data é opcional — quando preenchida, o saldo bruto do projeto naquela competência será verificado antes do envio.
              </p>
            </div>

            {/* Linhas de competência */}
            <div className="space-y-3">
              {competencias.map((comp, index) => (
                <div key={index} className="flex items-center gap-3">

                  {/* Índice */}
                  <span className="text-xs font-bold text-purple-700 w-5 text-center flex-shrink-0">
                    {index + 1}
                  </span>

                  {/* Data */}
                  <div className="flex-1">
                    <input
                      type="month"
                      value={comp.data ? comp.data.slice(0, 7) : ''}
                      onChange={e => handleCompetenciaChange(index, 'data', e.target.value ? `${e.target.value}-01` : '')}
                      className="w-full border-b border-gray-300 py-1 outline-none text-sm"
                    />
                    <span className="text-xs text-gray-400">Mês/Ano de competência (opcional)</span>
                  </div>

                  {/* Valor */}
                  <div className="flex-1">
                    <input
                      type="number"
                      step="0.01"
                      min="0.01"
                      placeholder="0,00"
                      value={comp.valor}
                      onChange={e => handleCompetenciaChange(index, 'valor', e.target.value)}
                      onWheel={e => e.target.blur()}
                      required
                      className={`w-full border-b py-1 outline-none text-sm font-mono [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none ${
                        comp.valor ? 'border-gray-300' : 'border-red-300'
                      }`}
                    />
                    <span className="text-xs text-gray-400">Valor (R$)</span>
                  </div>

                  {/* Botão remover — só aparece se há mais de 1 linha */}
                  {competencias.length > 1 ? (
                    <button
                      type="button"
                      onClick={() => removeCompetencia(index)}
                      className="flex-shrink-0 w-7 h-7 rounded-full bg-red-50 hover:bg-red-100 text-red-500 flex items-center justify-center transition-colors"
                      title="Remover competência"
                    >
                      <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                  ) : (
                    /* Placeholder para manter alinhamento */
                    <div className="w-7 flex-shrink-0" />
                  )}
                </div>
              ))}
            </div>

            {/* Rodapé: totalizador + botão adicionar */}
            <div className="mt-5 flex items-center justify-between">

              {/* Botão adicionar competência */}
              <button
                type="button"
                onClick={addCompetencia}
                className="flex items-center gap-2 text-purple-700 hover:text-purple-900 text-sm font-medium transition-colors"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
                </svg>
                Adicionar competência
              </button>

              {/* Totalizador */}
              {valorTotal > 0 && (
                <div className={`text-right text-sm rounded-lg px-4 py-2 ${
                  competenciasValidas
                    ? 'bg-green-50 text-green-700'
                    : 'bg-red-50 text-red-600'
                }`}>
                  <span className="font-mono">
                    {somaCompetencias.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </span>
                  <span className="text-xs ml-2 opacity-70">
                    / {valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </span>
                  {competenciasValidas
                    ? <span className="ml-2">✓</span>
                    : <span className="ml-2">≠</span>
                  }
                </div>
              )}
            </div>

            {/* Aviso de divergência */}
            {mostrarAvisoCompetencia && (
              <div className="mt-3 flex items-start gap-2 bg-amber-50 border border-amber-200 rounded-lg px-4 py-3">
                <svg className="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                </svg>
                <p className="text-xs text-amber-700">
                  A soma das competências ({somaCompetencias.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}) é diferente do valor total da nota ({valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}). Ajuste os valores antes de enviar.
                </p>
              </div>
            )}
          </section>
          {/* ──────────────────────────────────────────────────────────────── */}

          {/* Documentos Extras e Observações */}
          <section className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm space-y-6">
            <div>
              <label className="block text-base font-medium text-gray-900 mb-2">Documentos Extras</label>
              <p className="text-xs text-gray-400 mb-2">Informe links, nomes de arquivos ou qualquer referência a documentos complementares.</p>
              <textarea
                name="documentos_extras"
                rows="2"
                value={formData.documentos_extras}
                onChange={handleChange}
                placeholder="Ex: Link do Drive, nome do arquivo..."
                className="w-full border-b border-gray-300 focus:border-purple-600 outline-none py-1 text-sm resize-none"
              />
            </div>
            <div>
              <label className="block text-base font-medium text-gray-900 mb-2">Observações Gerais</label>
              <p className="text-xs text-gray-400 mb-2">Alguma informação adicional relevante para o financeiro?</p>
              <textarea
                name="observacoes_gerais"
                rows="3"
                value={formData.observacoes_gerais}
                onChange={handleChange}
                placeholder="Ex: Nota deve ser emitida até dia 20..."
                className="w-full border-b border-gray-300 focus:border-purple-600 outline-none py-1 text-sm resize-none"
              />
            </div>
          </section>

          {/* Botão de Envio */}
          <div className="pt-6">
            <button
              type="submit"
              disabled={isSubmitting || !competenciasValidas}
              title={!competenciasValidas ? 'Corrija os valores das competências antes de enviar' : ''}
              className="w-full bg-purple-900 text-white py-4 rounded-lg font-bold hover:bg-black transition-all shadow-xl disabled:opacity-50 disabled:cursor-not-allowed tracking-widest uppercase"
            >
              {isSubmitting ? 'Enviando para o Financeiro...' : 'Enviar Solicitação'}
            </button>
            {!competenciasValidas && valorTotal > 0 && (
              <p className="text-center text-xs text-red-500 mt-2">
                Ajuste as competências para habilitar o envio.
              </p>
            )}
          </div>

        </form>
      </main>
      </div>
          </div>

  );
};

export default GoogleFormFinanceiro;